<template>
  <!-- 右側検索パネルのコンテナ -->
  <Tab class="cx_vertical_fill" :tabs="tabs ? tabs:['検索条件']" :scrollWidth="70">    
    <div slot="tab0" class="cx_listView_search cx_vertical_scroll" ref="search">    
      <div class="cx_filter_items">
        <slot></slot>      
      </div>
       <div class="cx_search_buttons">
        <Button class="button" @click="onFavorite"  :caption="title" icon="favorite" v-if="favoriteVisible && $api.spMode == false" :disabled="listView && listView.isFavoriteEditable == false"/>
        <span class="cx_record_count" v-if="$api.spMode">抽出件数 : {{listView.totalRows}}件</span>  
        <Button class="button" @click="onSearch"  caption="一覧に戻る" icon="filter_list" v-if="$api.spMode"/>    
        </div>
    </div>
    <div slot="tab1" class="cx_listView_search cx_vertical_scroll" >    
      <slot name="tab1"></slot>      
    </div>     
    <div slot="tab2" class="cx_listView_search cx_vertical_scroll">
      <slot name="tab2"></slot>
    </div>  
  </Tab>
</template>
<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Components from '@/agiles/components';
import * as Common from '@/agiles/common';

@Component
export default class Search extends Vue {
  @Prop() public listView: Components.ListView;
  @Prop({default:null}) public tabs: string;
  @Prop({default:true}) public favoriteVisible: boolean;
  onFavorite(){
    if (this.listView) this.listView.onFavorite();
  }
  onSearch(){
    if (this.listView) this.listView.isSideFilter = false;
  }
  public get title(){
    return this.listView && this.listView.isFavorite ? 'お気に入り更新' : 'お気に入り追加';
  }
}

</script>
<style lang="scss">
.cx_listView_search {
  padding: 10px 30px 10px 30px;
  min-width: 370px;

  .cx_spmode & {
    height: 100%;
    display:flex;
    flex-direction: column;
    padding-right :0px; //cx_filter_items側でスクロールバーを表示
  }

  // .cx_favorite {
  //   display: flex;
  //   justify-content: flex-end;
  // }
  // .button{
  //   margin-top: 20px;
  // }

  .cx_filter_items{
    overflow-y:auto;

    .cx_spmode & {
      flex:1;
      padding-right:30px;
    }
  }
  .cx_search_buttons{
    margin-top:20px;
    width:100%;
    display: flex;
    align-items: center;
    justify-content: center;
    
    .cx_record_count{
      font-size: 14px;
      margin: 0px 20px;
    }
  }
}
</style>
